<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.66523607345581,10.06873607345581L13.66647607345581,12.077476073455811C13.86887607345581,12.27987607345581,13.99627607345581,12.56467607345581,13.99627607345581,12.87197607345581C13.99627607345581,13.49407607345581,13.49407607345581,13.99627607345581,12.87197607345581,13.99627607345581C12.56467607345581,13.99627607345581,12.27987607345581,13.86887607345581,12.077476073455811,13.66647607345581L10.06873607345581,11.66523607345581C9.25924607345581,12.18237607345581,8.29234607345581,12.49717607345581,7.25049607345581,12.49717607345581C4.34980607345581,12.49717607345581,2.0037760734558105,10.151186073455811,2.0037760734558105,7.25049607345581C2.0037760734558105,4.34980607345581,4.34980607345581,2.0037760734558105,7.25049607345581,2.0037760734558105C10.151186073455811,2.0037760734558105,12.49717607345581,4.34980607345581,12.49717607345581,7.25049607345581C12.49717607345581,8.28484607345581,12.18987607345581,9.25174607345581,11.66523607345581,10.06873607345581ZM3.5027960734558103,7.25070607345581C3.5027960734558103,9.31940607345581,5.181746073455811,10.998366073455811,7.25045607345581,10.998366073455811C9.319156073455812,10.998366073455811,10.99811607345581,9.31940607345581,10.99811607345581,7.25070607345581C10.99811607345581,5.18199607345581,9.319156073455812,3.5030460734558106,7.25045607345581,3.5030460734558106C5.181746073455811,3.5030460734558106,3.5027960734558103,5.18199607345581,3.5027960734558103,7.25070607345581Z"
          fill-rule="evenodd"
          fill="currentColor"
          fill-opacity="0.25"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallSearch',
} as DefineComponent
</script>
